import React, { useRef } from 'react';

/**
 * One row in the team table (T10.2). Role changes happen through the inline
 * role <select>; removal is two-step (row button → confirm) until T1's
 * ConfirmDialog primitive exists.
 */
function TeamMemberRow({ member, canManage, selfId, onRoleChange, onRemove, onResendInvite }) {
  const removeArmed = useRef(false);

  const handleRemove = () => {
    if (removeArmed.current) {
      removeArmed.current = false;
      onRemove(member.id);
      return;
    }
    removeArmed.current = true;
    window.setTimeout(() => {
      removeArmed.current = false;
    }, 2500);
  };

  return (
    <tr className={member.status === 'invited' ? 'is-invited' : undefined}>
      <td>
        <div className="settings-member">
          <div className="settings-member-avatar" aria-hidden="true">
            {member.name.split(' ').map((part) => part[0]).join('').slice(0, 2).toUpperCase()}
          </div>
          <div>
            <strong>{member.name}</strong>
            <span>{member.email}</span>
          </div>
        </div>
      </td>
      <td>
        {canManage && member.id !== selfId ? (
          <select
            aria-label={`Role for ${member.name}`}
            onChange={(event) => onRoleChange(member.id, event.target.value)}
            value={member.role}
          >
            <option value="agency-admin">agency-admin</option>
            <option value="operator">operator</option>
            <option value="viewer">viewer</option>
          </select>
        ) : (
          <span className="settings-role-static">{member.role}</span>
        )}
      </td>
      <td>
        <span className={`portal-pill pill-${member.status === 'active' ? 'paid' : 'draft'}`}>
          {member.status}
        </span>
      </td>
      <td>{member.lastActive}</td>
      <td className="settings-row-actions">
        {member.status === 'invited' && canManage && (
          <button className="settings-text-button" onClick={() => onResendInvite(member)} type="button">
            Resend invite
          </button>
        )}
        {canManage && member.id !== selfId && (
          <button className="settings-text-button danger" onClick={handleRemove} type="button">
            Remove
          </button>
        )}
        {member.id === selfId && <span className="settings-muted">You</span>}
      </td>
    </tr>
  );
}

export default TeamMemberRow;
